import React from 'react';
import { Button } from 'react-bootstrap';
import { AiOutlineCheck, GiMagnifyingGlass } from 'react-icons/all';
import Carte from './Carte';
import { useGetQuery } from '../../../Utils/api';
import { OptionsData } from '../../Dashboard/Options/Options';

interface Props {
    buttonfunction?: () => void;
}

const ForfaitAbonnement: React.FC<Props> = ({ buttonfunction }) => {
    const nbTotalActivites = useGetQuery<number>(['activites', 'count']);
    const queryAll = useGetQuery<OptionsData>(['options/all']);
    const fraisAbonnement = queryAll.data?.prix_abonnement;
    const fraisAnnulationAbonnement = queryAll.data?.frais_annulation_abonnement;
    const margeAnnulation = queryAll.data?.credit_annulation;
    return (
        <div>
            <Carte
                style={{ borderRadius: '20px', backgroundColor: '#52b8ff' }}
                title={'Abonnement'}
                subtitle={'Pour des calendriers annuels complets'}
                colorsubtitle="white"
                text={
                    <div>
                        <div>
                            <h6>Les avantages:</h6>
                        </div>
                        <div style={{ marginLeft: '15px', marginBottom: '25px' }}>
                            <span>
                                <AiOutlineCheck></AiOutlineCheck> Accès à toutes les {nbTotalActivites.data} activités.
                            </span>
                            <br></br>
                            <span>
                                <AiOutlineCheck></AiOutlineCheck> Création d'un calendrier des réservations.
                            </span>
                            <br></br>
                            <span>
                                <AiOutlineCheck></AiOutlineCheck> Accès à la réservation d'autobus.
                            </span>
                            <br></br>
                            <span>
                                <AiOutlineCheck></AiOutlineCheck> Suivi et accompagnement personnalisés.
                            </span>
                            <br></br>
                        </div>

                        <div>
                            <h6>Les clauses:</h6>
                        </div>

                        <div style={{ marginLeft: '15px', marginBottom: '25px' }}>
                            <span>
                                <GiMagnifyingGlass></GiMagnifyingGlass> Conditions possibles (CE, direction, etc.).
                            </span>
                            <br></br>
                            <span>
                                <GiMagnifyingGlass></GiMagnifyingGlass> Aucun frais de réservation <b>SI</b> l'activité
                                a lieu.
                            </span>
                            <br></br>
                            <span>
                                <GiMagnifyingGlass></GiMagnifyingGlass> Frais d'annulation: à partir de{' '}
                                {fraisAnnulationAbonnement}$ + txs.
                            </span>
                        </div>

                        <div style={{ textAlign: 'center', margin: '10px', height: '45px' }}>
                            <span style={{ textAlign: 'left' }}>
                                <b>{fraisAbonnement}$ + txs par école par année scolaire</b> <br></br>
                                <span style={{ color: 'white' }}>
                                    Inclut un crédit de {margeAnnulation}$ en frais d'annulation.
                                </span>
                            </span>
                            <br></br>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant="dark" style={{ borderRadius: '20px' }} onClick={buttonfunction}>
                                Demandez un abonnement
                            </Button>
                        </div>
                    </div>
                }
            ></Carte>
        </div>
    );
};

export default ForfaitAbonnement;
